module.exports = __webpack_public_path__ + "img/banner4.53adaa40.png";